import { useHydraMutation, HydraMutationParams } from './useHydraMutation';

export function useCreateUserApiKeysMutation(params?: HydraMutationParams) {
  return useHydraMutation('api/user_api_keys/users', params);
}
